enum ProjectModeNumber  {
    EpCapital = 1,
    Beyond = 2,
    Decomm = 3,
}

export default ProjectModeNumber